import { Check, Input } from "@frui.ts/bootstrap";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import AlertWithIcon from "views/common/alertWithIcon";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import React from "react";
import type RefundChargeViewModel from "viewModels/callCenter/search/charges/refundChargeViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import RefundPaymentForm from "./refundPaymentForm";
import ChangesDuringValidityWarning from "./changesDuringValidityWarning";

export const RefundChargeForm: ViewComponent<RefundChargeViewModel> = observer(({ vm }) => {
  return (
    <Form onSubmit={preventDefault(vm.onSave)}>
      <ChangesDuringValidityWarning vm={vm} />
      {vm.paymentInformationRequired && (
        <AlertWithIcon variant="info">{vm.translate("paymentInformationRequired")}</AlertWithIcon>
      )}
      {!vm.isAllowedToChangePaymentInformation && !vm.paymentInformationDenied && (
        <AlertWithIcon variant="warning">{vm.translate("paymentInformationNotAllowedToChange")}</AlertWithIcon>
      )}
      <div className="my-4">
        {(vm.isAllowedToChangePaymentInformation ||
          (!vm.isAllowedToChangePaymentInformation && !vm.paymentInformationRequired)) && (
          <Form.Row>
            <FormGroup as={Col} md={6} target={vm} property="officialRecordId">
              <FormLabel required={true}>{vm.translateAttribute("customerRefundCandidateRequest", "officialRecordId")}</FormLabel>
              <Input errorMessage={vm.officialRecordIdError()} />
            </FormGroup>
            {vm.paymentInformationOptional && vm.isAllowedToChangePaymentInformation && (
              <Form.Group as={Col} md={6} className="pt-md-6">
                <Check custom target={vm} property="fillBankAccount" label={vm.translate("fillBankAccount")} type="checkbox" />
              </Form.Group>
            )}
          </Form.Row>
        )}
        {vm.showPaymentInformation && <RefundPaymentForm vm={vm} />}
        {(vm.isAllowedToChangePaymentInformation ||
          (!vm.isAllowedToChangePaymentInformation && !vm.paymentInformationRequired)) && (
          <Form.Row>
            <Form.Group as={Col}>
              <Check
                custom
                target={vm.item}
                property="isWithoutRefundFee"
                label={vm.translate("isWithoutRefundFee")}
                type="checkbox"
              />
            </Form.Group>
          </Form.Row>
        )}
      </div>
    </Form>
  );
});

export default RefundChargeForm;
